export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11107.29dda6b7.jpg";